// Shared constants + empty templates for the ReleaseEditorDialog components.
export const inputCls =
  "w-full bg-white/5 border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 placeholder:text-slate-500";
export const labelCls = "text-[11px] uppercase tracking-widest text-slate-500 mb-1 block";

export const emptyAlbum = {
  title: "", type: "Single", version: "", display_artist: "",
  artists: [{ name: "", role: "primary", spotify_url: "", spotify_id: "", spotify_image: "", apple_music_url: "" }],
  primary_language: "en", genre: "", subgenre: "",
  label: "", parent_label: "Noizbloc Private Limited", catalog_number: "", upc: "",
  release_date: "", original_release_date: "", pre_order_date: "",
  c_line: "", p_line: "",
  compilation: false, audio_resolution: "High", dolby_atmos: false,
  cover_url: "", pdf_booklet_url: "",
  liner_notes: "",
  spotify_link: "", apple_music_link: "",
  performing_contributors: [],
  non_performing_contributors: [],
  restrictions: { territories_denied: [], services_denied: [] },
};

export const emptyTrack = () => ({
  title: "", version: "", display_artist: "",
  track_number: 1, volume: 1, length_seconds: 0,
  audio_language: "en",
  explicit: false, continuous_mix: false, album_only: false,
  writers: [{ name: "", role: "Lyricist/Composer" }],
  publishers: [{ name: "", pro: "" }],
  producers: "",
  c_line: "", p_line: "",
  withhold_mechanicals: false,
  lyrics: "",
  audio_url: "",
});

export const TERRITORIES = ["Africa", "Asia", "Caribbean", "Central America", "Europe", "Middle East", "North America", "Oceania", "South America", "Other"];

export const VIDEO_SERVICES = [
  "Amazon Video",
  "AMI Entertainment (Video)",
  "Apple (iTunes / Apple Music Video)",
  "Aspiro Video (Tidal / WiMP)",
  "Boomplay Video",
  "Fizy Video",
  "Line Music Video",
  "Meta Video",
  "NCT (NhacCuaTui) Video",
  "NetEase Video",
  "Qishui Yinyue Video",
  "RecoChoku Video",
  "RX Music (Video)",
  "Spotify Video",
  "VEVO / YouTube Video",
  "XITE Video",
  "Yango Play Video",
  "YouTube Video (Content ID)",
];

export const SERVICES = [
  "24-7 Entertainment", "7digital", "Amazon Music", "AMI Entertainment",
  "Anghami", "Apple (iTunes / Apple Music)", "Aspiro (Tidal / WiMP)", "Audible Magic",
  "Audible Magic for Twitch DJ", "Audiomack", "AWA", "Beatport", "Bleep", "Blurb",
  "BMAT", "Boomkat", "Boomplay", "Bugs", "Claro Música", "CRIMSON TECHNOLOGY, Inc.",
  "Cubomusica", "Deezer", "District", "Facebook", "Fit Radio", "Fizy", "FLO",
  "Gaana", "Genie Music", "Gracenote", "Hard Wax", "HDtracks HRA", "HIGHRESAUDIO",
  "Hoopla", "Huawei Music", "iHeartRadio", "IIM / Starlux", "Instagram", "JioSaavn",
  "Joox", "Kantar (France)", "Kantar (UK)", "KKBox", "Kuack Media Group", "Lickd",
  "Line Music", "LiveOne (LiveXLive)", "mdundo", "MediaNet", "Melon", "Meta Audio",
  "MOOV", "muud", "Napster", "Nasjonalbiblioteket (National Library of Norway)",
  "NCT (NhacCuaTui)", "NetEase", "OSCIL8 / Sollos", "Pandora", "Peloton", "Pex",
  "Phononet", "Qishui Yinyue", "Qobuz", "QQ Music", "Rakuten Music", "RecoChoku",
  "RX Music", "Shazam", "Simbals", "Sirius XM", "SoundCloud",
  "SoundCloud (Content ID)", "SoundCloud Go", "SoundExchange", "Spotify",
  "Supernatural", "Tencent (KuGou / Kowu / QQ Music)", "TikTok", "TiVo",
  "Touch Inflight Solutions", "TouchTunes", "TraxSource", "Trebel", "TunedGlobal",
  "Twitch", "VIBE", "VK Music", "Yandex Music", "Yango Play", "YouTube (Content ID)",
  "YouTube Music", "Zing MP3",
];
